<div class="loading-overlay spinner" *ngIf="isSpinnerVisible()">
    <div class="loader"></div>
    <p [innerHtml]="progressMeasurementService.message"></p>
    <button
        type="button"
        *ngIf="hasCancelButton()"
        class="btn btn-primary"
        style="cursor: pointer"
        (click)="cancel()">
        Cancel
    </button>
</div>
